import React, { useEffect } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CarCard from '../CarCard/CarCard';

const CarouselSection = ({ cars, sliderRef }) => {
  useEffect(() => {
    if (sliderRef?.current) {
      sliderRef.current.slickGoTo(0);
    }
  }, [cars]);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0px',
          infinite: true
        }
      }
    ]
  };

  return (
    <div className="w-full overflow-hidden">
      {cars.length > 0 ? (
        <Slider ref={sliderRef} {...settings} className="car-carousel">
          {cars.map((car, index) => (
            <div key={`${car.name}-${index}`} className="px-2">
              <CarCard car={car} />
            </div>
          ))}
        </Slider>
      ) : (
        <div className="text-center py-8 text-gray-500">
          No cars match the selected filters
        </div>
      )}
      <style>
        {`
          .car-carousel .slick-track {
            display: flex !important;
            margin-left: 0;
            margin-right: 0;
          }
          
          .car-carousel .slick-slide {
            height: inherit !important;
            float: none;
            padding: 0 8px;
          }
          
          .car-carousel .slick-slide > div {
            height: 100%;
          }
          
          @media (max-width: 640px) {
            .car-carousel .slick-track {
              display: flex !important;
            }
            
            .car-carousel .slick-slide {
              padding: 0 4px;
            }
            
            .car-carousel .slick-list {
              overflow: hidden !important;
            }
            
            /* Fix for visual alignment while maintaining scroll functionality */
            .car-carousel .slick-slide.slick-active {
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
};

export default CarouselSection;